import MobileIntelligentQA from '@/pages/Mobile/PageComponents/IntelligentQA';
import { Display } from '@/components/Display/Display';
const IntelligentQA = (props) => {
    const { side = 'mobile', ...otherProps } = props;
    return (
        <>
            <Display show={side === 'mobile'}>
                <MobileIntelligentQA {...otherProps}></MobileIntelligentQA>
            </Display>
        </>
    );
};

export default IntelligentQA;
